import React from 'react';
import { RBHBox, RBHText } from '../../../../../shared/components';
import Lottie from 'lottie-react';
import { Colors } from '../../../../../shared/theme';
import styles from './styles';
import successAnimation from '../../../../../shared/resources/animation/success.json';
import './styles.css';
import { useSelector } from 'react-redux';
import { INVITATION_STATE_KEY, InvitationConfig, invitationStateSelector, InvitationStep } from '../redux/invitation-reducer';

export const InvitationSuccessSection = () => {
	const invitationConfig = useSelector(
		invitationStateSelector(INVITATION_STATE_KEY.CONFIG),
	) as InvitationConfig;
	const invitationStep = useSelector(
		invitationStateSelector(INVITATION_STATE_KEY.STEP),
	) as InvitationStep;

	if (invitationStep !== 'success' && !invitationConfig?.isTncAccepted) {
		return null;
	}
	return (
		<RBHBox
			className='invitation-success-section'
			style={styles.successSection}
		>
			<Lottie
				animationData={successAnimation}
				autoplay
				style={styles.successAnimation}
			/>
			<RBHText
				className='invitation-success-title'
				style={styles.sectionSuccessTitle}
			>
				ได้รับข้อมูลของคุณแล้ว
			</RBHText>
			<RBHText
				className='invitation-success-title'
				style={styles.sectionSuccessTitle}
			>
				รอการติดต่อกลับจาก Robinhood ได้เลย
			</RBHText>
			<RBHText
				className='invitation-success-sub-title'
				style={styles.sectionSuccessSubTitle}
			>
				<span>หากมีข้อสงสัยเพิ่มเติมติดต่อ LINE OA</span>{' '}
				<a
					href='https://line.me/R/ti/p/%40robinhoodshop'
					style={{ color: Colors.violet }}
				>
					@robinhoodshop
				</a>
			</RBHText>
		</RBHBox>
	);
};
